module.exports = __webpack_public_path__ + "static/fonts/UTM-Erie-Black.258d184.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/UTM-Erie-Black.ttf
// module id = lWoS
// module chunks = 0